import { useSelector } from 'react-redux';
import { IAppState } from '../../store/types';

const useCurrentBusiness = (): IAppState => {
  const selectedBusiness = useSelector((state: IAppState) => state);
  return { ...selectedBusiness };
};

export default useCurrentBusiness;
